import { colors } from '@flowwai-frontend/design-system'

const themes = {
   light: {
      toastUtils: {
         refreshButtonRetryIconColor: colors['error-700']
      }
   },
   dark: {}
}

export const commonTheme = themes.light
